import PathSection from '../api/pathSection';
import { applicationDestroy } from './applicationActions';

export const destroyPathSection = applicationDestroy(PathSection);
